var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-chart"},[_c('div',{ref:"chartWrapper",staticClass:"charts-wrapper",attrs:{"id":"chartWrapper"}}),_c('div',{staticClass:"remove-credit"})])}
var staticRenderFns = []

export { render, staticRenderFns }